import { Col, Row, Card, Space, Table, Typography, Skeleton } from 'antd';
import { getTransactions } from 'api-services/user-plan';
import useDecodeToken from 'hooks/use-decode-token';
import { useEffect, useState } from 'react';
import Helper from 'utilities/helper';

function UserHistory() {
  const { Title, Paragraph } = Typography;

  const { userId, subscriptionId, planId } = useDecodeToken();
  const [skeleton, setSkeleton] = useState(true);

  /* Component States */
  const [transactionsArr, setTransactionsArr] = useState([]);

  /* Defining Columns */
  const columns = [
    {
      title: 'Invoice#',
      dataIndex: 'uid',
    },
    {
      title: 'Status',
      dataIndex: 'transactionStatus',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      render: (amount) => <span>{`$${amount}`}</span>,
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      render: (dateString) => Helper.getShortDate(dateString),
    },
  ];

  useEffect(() => {
    const getAllTransactions = async () => {
      const response = await getTransactions(userId, subscriptionId); //getting transaction history
      if (response.status === 200) {
        setTransactionsArr(response.data);
      }
      setSkeleton(false);
    };

    if ((userId, subscriptionId)) {
      //checking if plan even exists
      getAllTransactions();
    }
  }, [userId, subscriptionId]);

  return (
    <>
      {planId && (
        <Row>
          <Col span={24}>
            <Space size='middle' direction='vertical'>
              <Col span={16} className='billing-history'>
                <Title level={4}>Billing History</Title>
                <Paragraph>Showing invoices within the past 12 months.</Paragraph>
                <Card>
                  {skeleton && <Skeleton active />}
                  {!skeleton && (
                    <Table
                      columns={columns}
                      dataSource={transactionsArr}
                      size='small'
                      rowKey={(record) => record.uid}
                      pagination={{
                        pageSize: 10,
                        hideOnSinglePage: true,
                      }}
                    />
                  )}
                </Card>
              </Col>
            </Space>
          </Col>
        </Row>
      )}
    </>
  );
}

export default UserHistory;
